import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
// components
import RMDRLink from "@/components/RMDRLink";
import RMDRImage from "@/components/RMDRImage";
import MNPGV2 from "./MNPGV2";
// utilities
import { 
    outerNameDescriptionLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
// types
import { TMainPageLayoutV3 } from "../type";
import TClientSiteSettingDetail from "@/cms/types/TClientSiteSettingDetail";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";
import ERedirectType from "@/cms/enums/ERedirectType";
// types
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TResource from "@/cms/types/TResource";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";


type TRender = {

    webApplicationLanguageISOCode:string;
    resources: TResource[];
    languageVersion:TLanguageVersionList|TLanguageVersionDetail|undefined;

    templates:TClientMainPageItemList[];
    template:TClientMainPageItemList;

}

const Render = ( props: TRender ) => {
    console.log("MNPG046.OffCanvasMenu: ", props);

    const location = useLocation();
    const [toggleMenu, setToggleMenu] = useState(false);

    useEffect(
        () => {
            handleCloseMenu();
        }, [location]
    )

    const handleOpenMenu = () => {
        document.body.classList.add('overflow-hidden');
        setToggleMenu(true);
    }

    const handleCloseMenu = () => {
        document.body.classList.remove('overflow-hidden');
        setToggleMenu(false);
    }

    return (
        <>
            <div className="header__hamburger d-xl-none my-auto">
                <div className="sidebar__toggle" onClick={() => handleOpenMenu()}>
                    <i className="fas fa-bars"></i>
                </div>
            </div>
            <div className="offcanvas__content fix-area d-xl-none">
                <div className={clsx("offcanvas__info", {"info-open":toggleMenu})}>
                    <div className="offcanvas__wrapper">
                        <div className="offcanvas__content">

                            <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                                <div className="offcanvas__logo">
                                    <RMDRLink
                                        text={null}
                                        title={props.languageVersion?.name}
                                        hasNavigationDestination={true}
                                        navigationURL={`/${props.webApplicationLanguageISOCode}`}
                                        redirectType={ERedirectType.STAY_CURRENT_PAGE}
                                        isShowAlways={true}
                                    >
                                        <RMDRImage
                                            resourceType={EResourceType.LOGO_DEFAULT} 
                                            resources={props.resources} 
                                            sizeType={ESizeType.X06}
                                            alt={props.languageVersion?.name} 
                                            title={props.languageVersion?.name}
                                        />
                                    </RMDRLink>
                                </div>
                                <button className="offcanvas__close" onClick={() => handleCloseMenu()}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>

                            <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />

                        </div>
                    </div>
                </div>
            </div>
            <div
                className={clsx("offcanvas__overlay d-block d-xl-none",{"overlay-open":toggleMenu})}
                onClick={() => handleCloseMenu()}
            />
        </>
    )
}


const MNPG046 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG046.rendered: ", props);

    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);
    const siteSettingsPayload:TClientSiteSettingDetail = useSelector((state:any) => state.SiteSettingStore.details.payload, shallowEqual);
    
    if ( !props.template || !props.templates ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(siteSettingsPayload.languageVersions);

    return (
        <Render templates={props.templates} template={props.template} resources={siteSettingsPayload.resources} webApplicationLanguageISOCode={webApplicationLanguageISOCode} languageVersion={languageVersion} />
    )
}

export default MNPG046;
